import dayjs from 'dayjs';
import { decodeJwt } from 'jose';

const DEFAULT_REFRESH_DAYS = 7;

const fallbackExpiry = () => dayjs().add(DEFAULT_REFRESH_DAYS, 'day').toDate();

//* refreshToken은 opaque(비 JWT)일 수 있어 decodeJwt가 던진다 — 그때만 고정 수명으로 대체한다
export const resolveRefreshTokenExpiry = (refreshToken: string): Date => {
  try {
    const { exp } = decodeJwt(refreshToken);

    return exp ? new Date(exp * 1_000) : fallbackExpiry();
  } catch {
    return fallbackExpiry();
  }
};
